import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconRuler16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconRuler16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M4 2.5V8h3V7H5.5a.5.5 0 0 1 0-1H7V5H5.5a.5.5 0 0 1 0-1H7V2.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5M4 9v1.5a.5.5 0 0 0 1 0V9h1v1.5a.5.5 0 0 0 1 0V9h1v1.5a.5.5 0 0 0 1 0V9h1v1.5a.5.5 0 0 0 1 0V9h1.5a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5zm8.5-1H8V2.5A1.5 1.5 0 0 0 6.5 1h-2A1.5 1.5 0 0 0 3 2.5V8h-.5A1.5 1.5 0 0 0 1 9.5v2A1.5 1.5 0 0 0 2.5 13H3v.5A1.5 1.5 0 0 0 4.5 15h2A1.5 1.5 0 0 0 8 13.5V13h4.5a1.5 1.5 0 0 0 1.5-1.5v-2A1.5 1.5 0 0 0 12.5 8M4 13v.5a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V13z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconRuler16);
